<template lang='pug'>
.row
  h2(v-text='"MOST READ ARTICLES"')
  .row.most-read-articles
    .col-3(v-for='article in articles' :key='article.id')
      article-card(v-bind='article')
</template>
<script>
import ArticleCard from './card.vue'
export default {
  components: {
    'article-card': ArticleCard
  },
  props: {
    articles: { type: Array, default: () => [] }
  }
}
</script>
<style lang='scss' scoped>
h2 {
  width: 100%;

  font-size: 16px;
  text-align: center;
  margin-bottom: 19px;
}
</style>
